/** Display labels only; role IDs and authorization names remain unchanged. */
export function employeeRoleLabel(role: string | null | undefined): string {
    switch (role?.trim().toLowerCase()) {
        case 'member': return 'Mitarbeiter';
        case 'superior': return 'Vorgesetzter';
        case 'admin': return 'Administrator';
        default: return role || '–';
    }
}
